// Constants
import { OrgCityConfigTypes } from "../../../constants/GeneralConstants";

// remove keys from object whose values is empty array
function filterTgAndTgAttrMap(clonedTgAttributesMap = {}) {
  const filteredMap = Object.keys(clonedTgAttributesMap)
    .filter(
      (key) =>
        Array.isArray(clonedTgAttributesMap[key]) &&
        clonedTgAttributesMap[key].length != 0
    )
    .reduce((acc, key) => {
      acc[key] = clonedTgAttributesMap[key];
      return acc;
    }, {});

  return filteredMap;
}

// select/un-select :: update Tg Attributes selection Map
export function updateTgAttributesMap(
  tgAttributesMap = {},
  tgAttribute = {},
  isSelect = true // key used for "select = true" & "unselect = false"
) {
  const { tgAttrId, tgId } = tgAttribute || {};

  const clonedTgAttributesMap = { ...tgAttributesMap };

  const existingTgIds = Object.keys(clonedTgAttributesMap);

  // append tg in map
  if (!existingTgIds.includes(tgId)) {
    clonedTgAttributesMap[tgId] = [];
  }

  // update tg attr for "Select"
  if (isSelect) {
    const selectedTgToAddTgAttr = clonedTgAttributesMap[tgId];
    const clonedSelectedTgToAddTgAttr = [...selectedTgToAddTgAttr];
    clonedSelectedTgToAddTgAttr.push(tgAttribute);
    clonedTgAttributesMap[tgId] = clonedSelectedTgToAddTgAttr;
  }

  // update tg attr for "Un Select"
  if (!isSelect) {
    const selectedTgToRemoveTgAttr = clonedTgAttributesMap[tgId];
    const clonedSelectedTgToRemoveTgAttr = [...selectedTgToRemoveTgAttr];

    const tgAttrIndex = clonedSelectedTgToRemoveTgAttr.findIndex(
      (tgaAttr) => tgaAttr.tgAttrId === tgAttrId
    );

    // only splice array when item is found
    if (tgAttrIndex > -1) {
      clonedSelectedTgToRemoveTgAttr.splice(tgAttrIndex, 1);
    }

    // update after removing tg attribute
    clonedTgAttributesMap[tgId] = clonedSelectedTgToRemoveTgAttr;
  }

  // filter map by removing tg with no tg attr
  const filteredTgAndTgAttrMap = filterTgAndTgAttrMap(clonedTgAttributesMap);

  // final return
  return filteredTgAndTgAttrMap;
}

// get Selected Freq Opt Locations
export function getSelectedFreqOptLocations(
  selectedRegionAndZonesMap = {},
  regionId
) {
  const regionSelectedZones = selectedRegionAndZonesMap?.[regionId] || [];

  if (regionSelectedZones.length === 0) {
    return [];
  }

  const selectedSubZones = [];
  regionSelectedZones.forEach((eachZone) => {
    const { subZones = [] } = eachZone || {};
    const subZonesData = subZones || [];
    selectedSubZones.push(...subZonesData);
  });

  return selectedSubZones;
}

/**
 * get Planning page Query Params
 */
export function getPlanningQueryParams(search) {
  const queryCityId = new URLSearchParams(search).get("_city");
  const isPureDooh = new URLSearchParams(search).get("_isPureDooh");
  const isAddCity = new URLSearchParams(search).get("_isAddCity");

  return {
    queryCityId,
    isPureDooh: Boolean(isPureDooh),
    isAddCity: Boolean(isAddCity),
  };
}

// get Campaign Existing Cities Map
export function getCampaignExistingCitiesMap(campaign, isAddCity = false) {
  const existingCitiesMap = {};

  // if no cities exist and not adding new city to campaign
  if (!isAddCity || !campaign || Object.keys(campaign).length === 0) {
    return existingCitiesMap;
  }

  const { infoByCity = {} } = campaign || {};
  Object.keys(infoByCity).forEach((cityId) => {
    existingCitiesMap[cityId] = true;
    return;
  });

  // final return
  return existingCitiesMap;
}

// getting road stretches org medias
export function getRoadStretchesOrgMedias(roadStretchData = []) {
  const staticMedias = [];
  const digitalMedias = [];

  // if stretches not present
  if (!roadStretchData || roadStretchData.length === 0) {
    return { staticMedias, digitalMedias };
  }

  roadStretchData.forEach((roadStretchInfo) => {
    const orgMedias = roadStretchInfo?.orgMedias || [];

    orgMedias.forEach((media) => {
      if (media.isDigital) {
        digitalMedias.push(media);
      } else {
        staticMedias.push(media);
      }
    });
  });

  return { staticMedias, digitalMedias };
}

// Filter stretches which have imp/tgImp
export function getImpFilteredStretches(roadStretchData = [], tgId) {
  // filter stretches based on imp/tgImp
  const impFilteredStretches = [];

  // if no stretches present
  if (roadStretchData.length === 0) {
    return impFilteredStretches;
  }

  // else filter
  roadStretchData.forEach((stretch) => {
    const { otsAvg, otsLitAvg, targetOtsLit, targetOts } = stretch || {};
    const finalImp = otsLitAvg ?? otsAvg;
    const finalTgImp = targetOtsLit ?? targetOts;

    // if tg NOT applied, filter based on "imp"
    if (!tgId && finalImp) {
      impFilteredStretches.push(stretch);
      return;
    }

    // if tg applied, filter based on "imp" and "tgImp"
    if (tgId && finalImp && finalTgImp) {
      impFilteredStretches.push(stretch);
    }
  });
  return impFilteredStretches;
}

// get City Config All Media Types
export function getCityConfigAllMediaTypes(cityConfig = {}) {
  // media types map from cityCOnfig
  const mediaTypesGroupsMap = cityConfig[OrgCityConfigTypes.mediaType] || {};

  // "new Set" to remove duplicates like "Impact > 500 sq ft"
  const allMediaTypes = Array.from(
    new Set(
      Object.values(mediaTypesGroupsMap).flatMap((group) => group.types || [])
    )
  );

  return allMediaTypes;
}
